'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handlers = require('./handlers');

var updateModalState = function updateModalState(data) {
  var id = data.name;

  var container = 'modal';
  var change = 'modal';

  var name = data.name,
      close = data.close;

  var active = close ? undefined : name;

  (0, _handlers.setState)({ id: id, change: change, active: active, container: container });
};

exports.default = {
  updateState: updateModalState
};